// extracted by mini-css-extract-plugin
export default {"image":"B0-z","loaded":"C0-z"};